export default "__VITE_ASSET__DlhoJ8d3__"